export default "__VITE_ASSET__DDGGd_hO__"